import { render, staticRenderFns } from "./CardProgramDetails.vue?vue&type=template&id=cba4e79e&scoped=true"
import script from "./CardProgramDetails.vue?vue&type=script&lang=js"
export * from "./CardProgramDetails.vue?vue&type=script&lang=js"
import style0 from "./CardProgramDetails.vue?vue&type=style&index=0&id=cba4e79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba4e79e",
  null
  
)

export default component.exports